import React, { Component } from "react";
import { Row, Col, Button, FormControl, Form, Modal } from "react-bootstrap";
import {
  MudarSenhaEntregador,
  ListarEntregadores,
  CadastrarEntregador,
  DeletarEntregador,
  EditarEntregador,
} from "../../providers/EntregadorProvider";
import TBLEntregadores from "../../components/TBLEntregadores";
import { ValidarCep } from "../../utils/Validar";
import InputMask from "react-input-mask";
import Select from "react-select";
import { toast } from "react-toastify";
import { Switch, withStyles } from "@material-ui/core";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";
import { getCEP } from "../../providers/AdminProvider";
import { BuscarEntregadorPorNomeOuCpf } from "../../providers/BuscaProvider";

const options = [
  { value: "Automovel", label: "Automóvel" },
  { value: "Motocicleta", label: "Motocicleta" },
];

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#701B8C",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#701B8C",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default class Entregador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {
        nome: "",
        cpf: "",
        rg: "",
        telefone: "",
        cnh: "",
        cooperativa: "default",
        veiculo: {
          tipo: "",
          placa: "",
          capacidade: "",
        },
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          cep: "",
        },
        usuario: {
          email: "",
          senha: "",
        },
      },
      pedidos: [],
      errorSenha: "",
      confirmaSenha: "",
      Entregadores: [],
      row: null,
      EntregadorSelecionado: null,
      showModalEntregador: false,
      showModalAlert: false,
      showModalSenha: false,
      showModalDespacho: false,
      errorCadastro: "",
      validarCep: true,
      modoEditarEntregador: false,
      modoVisualizarEntregador: false,
      form: {
        nome: "",
        cpf: "",
        rg: "",
        telefone: "",
        cnh: "",
        cooperativa: "default",
        veiculo: {
          tipo: null,
          placa: "",
          capacidade: "",
        },
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          cep: "",
        },
        usuario: {
          email: "",
          senha: "",
        },
        entregador_fixo: false,
        estabelecimento_fixo: null,
      },
      limitP: 1,
      loadingP: false,
      pageP: 1,
      mensagemAlert: "",
      variantAlert: "",
      estabelecimentos: [],
    };
  }
  handleCloseModalEntregador = () => {
    this.setState({ showModalEntregador: false });
    this.limparForm();
  };

  handleShowModalEntregador = () => {
    this.setState({ showModalEntregador: true });
  };
  handleShowModalSenha = () => {
    this.setState({ showModalSenha: true });
  };
  handleCloseModalSenha = () => {
    this.setState({ showModalSenha: false });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else if (variant === "error") {
      toast.error(mensagem);
    } else {
      toast.info(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  limparForm = () => {
    this.setState({
      error: {
        nome: "",
        cpf: "",
        rg: "",
        telefone: "",
        cnh: "",
        cooperativa: "default",
        veiculo: {
          tipo: "",
          placa: "",
          capacidade: "",
        },
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          cep: "",
        },
        usuario: {
          email: "",
          senha: "",
        },
      },
      pedidos: [],
      pagesP: 1,
      pageP: 1,
      loadingP: false,
      limitP: 10,
      EntregadorSelecionado: null,
      showModalEntregador: false,
      showModalAlert: false,
      errorCadastro: "",
      errorSenha: "",
      modoEditarEntregador: false,
      modoVisualizarEntregador: false,
      validarCep: true,
      form: {
        nome: "",
        cpf: "",
        rg: "",
        telefone: "",
        cnh: "",
        cooperativa: "default",
        veiculo: {
          tipo: {},
          placa: "",
          capacidade: "",
        },
        endereco: {
          rua: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: "Brasil",
          cep: "",
        },
        usuario: {
          email: "",
          senha: "",
        },
        entregador_fixo: false,
        estabelecimento_fixo: null,
      },
      mensagemAlert: "",
      variantAlert: "",
    });
  };

  preencherFormEdit = (dados) => {
    this.setState({
      EntregadorSelecionado: dados,
      form: {
        nome: dados.nome,
        cpf: dados.cpf,
        rg: dados.rg,
        telefone: dados.telefone,
        cnh: dados.cnh,
        cooperativa: "default",
        veiculo: {
          tipo: {
            label: dados.veiculo.tipo,
            value: dados.veiculo.tipo,
          },
          placa: dados.veiculo.placa,
          capacidade: dados.veiculo.capacidade,
        },
        endereco: {
          rua: dados.endereco.rua,
          numero: dados.endereco.numero,
          bairro: dados.endereco.bairro,
          cidade: dados.endereco.cidade,
          estado: dados.endereco.estado,
          pais: dados.endereco.pais,
          cep: dados.endereco.cep,
        },
        usuario: {
          email: dados.usuario.email,
          senha: "",
        },
        entregador_fixo: dados.entregador_fixo,
        estabelecimento_fixo: dados.estabelecimento_fixo
          ? {
              value: dados.estabelecimento_fixo._id,
              label: dados.estabelecimento_fixo.nome_fantasia,
            }
          : null,
      },
      modoEditarEntregador: true,
      modoVisualizarEntregador: true,
    });
    this.handleShowModalEntregador();
  };

  handleShowModalDespacho = () => {
    this.setState({ showModalDespacho: true });
  };
  handleCloseModalDespacho = () => {
    this.setState({ showModalDespacho: false });
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.setState({ EntregadorSelecionado: dados });
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ EntregadorSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  pesquisarCEP = async (cep) => {
    if (cep) {
      try {
        const res = await getCEP(cep);
        if (res.erro) {
          this.setState({ validarCep: false });
        } else {
          this.setState({
            form: {
              ...this.state.form,
              endereco: {
                ...this.state.form.endereco,
                rua: res.logradouro,
                bairro: res.bairro,
                cidade: res.localidade,
                estado: res.uf,
                cep: cep,
                pais: "Brasil",
              },
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  validarForm = (form, isCadastro) => {
    let isValid = true;
    let error = this.state.error;
    for (let key in form) {
      if (key === "endereco") {
        for (let j in form[key]) {
          if (form[key][j] === "" || form[key][j] === null) {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: `Campo ${j} obrigatório`,
              },
            };
            isValid = false;
          } else if (j === "cep" && !this.state.validarCep) {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: "CEP inválido",
              },
            };
            isValid = false;
          } else {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: "",
              },
            };
          }
        }
      } else if (key === "usuario") {
        for (let j in form[key]) {
          if (isCadastro) {
            if (form[key][j] === "" || form[key][j] === null) {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: `Campo ${j} obrigatório`,
                },
              };
              isValid = false;
            } else {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: "",
                },
              };
            }
          } else {
            if ((form[key][j] === "" || form[key][j] === null) && j !== "senha") {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: `Campo ${j} obrigatório`,
                },
              };
              isValid = false;
            } else {
              error = {
                ...error,
                [key]: {
                  ...error[key],
                  [j]: "",
                },
              };
            }
          }
        }
      } else if (key === "veiculo") {
        for (let j in form[key]) {
          if (form[key][j] === "" || form[key][j] === null) {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: `Campo ${j} obrigatório`,
              },
            };
            isValid = false;
          } else {
            error = {
              ...error,
              [key]: {
                ...error[key],
                [j]: "",
              },
            };
          }
        }
      } else {
        if (
          form[key] === "" ||
          (form[key] === null &&
            key != "entregador_fixo" &&
            key != "estabelecimento_fixo")
        ) {
          error = {
            ...error,
            [key]: `Campo ${key} obrigatório`,
          };
          isValid = false;
        } else {
          error = { ...error, [key]: "" };
        }
      }
    }
    this.setState({ error });
    return isValid;
  };
  goTop = () => {
    document.getElementById("modal-entregador").scrollIntoView({ behavior: "smooth" });
  };

  cadastrarEntregador = async () => {
    let formEntregador = {};
    let formUsuario = {};
    let formEndereco = {};
    if (this.validarForm(this.state.form, true)) {
      formEntregador = {
        nome: this.state.form.nome,
        cpf: this.state.form.cpf,
        rg: this.state.form.rg,
        cnh: this.state.form.cnh,
        cooperativa: "default",
        telefone: this.state.form.telefone,
        veiculo: {
          tipo: this.state.form.veiculo.tipo.value,
          placa: this.state.form.veiculo.placa,
          capacidade: this.state.form.veiculo.capacidade,
        },
        entregador_fixo: this.state.form.entregador_fixo,
        estabelecimento_fixo: this.state.form.estabelecimento_fixo
          ? this.state.form.estabelecimento_fixo.value
          : undefined,
      };
      formUsuario = {
        email: this.state.form.usuario.email,
        senha: this.state.form.usuario.senha,
        tipo: "entregador",
      };
      formEndereco = {
        rua: this.state.form.endereco.rua,
        numero: this.state.form.endereco.numero,
        bairro: this.state.form.endereco.bairro,
        cidade: this.state.form.endereco.cidade,
        estado: this.state.form.endereco.estado,
        pais: this.state.form.endereco.pais,
        cep: this.state.form.endereco.cep,
      };
      try {
        const response = await CadastrarEntregador(
          formEntregador,
          formEndereco,
          formUsuario,
        );
        if (response) {
          const list = await ListarEntregadores();
          this.setState({ Entregadores: list });
          this.limparForm();
          this.handleShowAlert("Entregador cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert(error.error, "error");
      }
    } else {
      this.setState({ errorCadastro: "Informações obrigatórias (*) faltando" });
      this.goTop();
      return;
    }
  };

  editarEntregador = async () => {
    let formEntregador = {};
    let formUsuario = {};
    let formEndereco = {};

    if (!this.validarForm(this.state.form, false)) {
      this.setState({ errorCadastro: "Informações obrigatórias (*) faltando" });
      this.goTop();
      return;
    } else {
      formEntregador = {
        nome: this.state.form.nome,
        cpf: this.state.form.cpf,
        rg: this.state.form.rg,
        telefone: this.state.form.telefone,
        cnh: this.state.form.cnh,
        cooperativa: "default",
        veiculo: {
          tipo: this.state.form.veiculo.tipo.value,
          placa: this.state.form.veiculo.placa,
          capacidade: this.state.form.veiculo.capacidade,
        },
        entregador_fixo: this.state.form.entregador_fixo,
        estabelecimento_fixo: this.state.form.estabelecimento_fixo.value,
      };
      formEndereco = {
        rua: this.state.form.endereco.rua,
        numero: this.state.form.endereco.numero,
        bairro: this.state.form.endereco.bairro,
        cidade: this.state.form.endereco.cidade,
        estado: this.state.form.endereco.estado,
        pais: this.state.form.endereco.pais,
        cep: this.state.form.endereco.cep,
      };
      formUsuario = {
        email: this.state.form.usuario.email,
        senha:
          this.state.form.usuario.senha !== ""
            ? this.state.form.usuario.senha
            : undefined,
        tipo: "entregador",
      };
      try {
        const response = await EditarEntregador(
          formEntregador,
          formEndereco,
          formUsuario,
          this.state.EntregadorSelecionado,
        );
        if (response) {
          const list = await ListarEntregadores();
          this.setState({ Entregadores: list });
          this.limparForm();
          this.handleShowAlert("Entregador editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar Entregador", "error");
      }
    }
  };

  deletarEntregador = async () => {
    try {
      const response = await DeletarEntregador(this.state.EntregadorSelecionado);
      if (response) {
        const list = await ListarEntregadores();
        this.setState({ Entregadores: list });
        this.limparForm();
        this.handleShowAlert("Entregador deletado com sucesso", "secondary");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar Entregador", "error");
    }
  };

  async componentDidMount() {
    const response = await ListarEntregadores();
    await this.getEstabelecimentos();
    this.setState({ Entregadores: response });
  }
  confirmaSenha = async (user) => {
    if (
      this.state.form.usuario.senha === this.state.confirmaSenha &&
      this.state.confirmaSenha !== ""
    ) {
      await MudarSenhaEntregador(user.usuario, this.state.form.usuario.senha);
      this.handleCloseModalSenha();
      this.handleCloseModalEntregador();
      this.handleShowAlert("Senha atualizada com sucesso", "success");
    } else {
      this.setState({ errorSenha: "Senhas não coincidem *" });
    }
  };

  pesquisarEntregador = async (value) => {
    if (value === "") {
      const list = await ListarEntregadores();
      this.setState({ Entregadores: list });
    } else {
      const response = await BuscarEntregadorPorNomeOuCpf(value);
      this.setState({ Entregadores: response });
    }
  };

  getEstabelecimentos = async () => {
    const data = await ListarEstabelecimentosSemPaginacao();
    if (data) {
      this.setState({
        estabelecimentos: data.map((e) => ({
          label: e.nome_fantasia,
          value: e._id,
        })),
      });
    }
  };

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Entregadores</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalEntregador();
              }}
            >
              Cadastrar Entregador
            </Button>
          </Col>
        </Row>
        <br></br>
        <div>
          <FormControl
            placeholder="Pesquisar Entregadores"
            onChange={(e) => this.pesquisarEntregador(e.target.value)}
          />
          <TBLEntregadores
            data={this.state.Entregadores}
            numRows={10}
            dataCallback={this.receberDadosTabela}
          ></TBLEntregadores>
        </div>
        <Modal
          id="modal-entregador"
          size="xl"
          show={this.state.showModalEntregador}
          onHide={this.handleCloseModalEntregador}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarEntregador ? "Entregador" : "Cadastrar Entregador"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            {this.state.modoVisualizarEntregador ? (
              <Button
                variant="primary"
                style={{ float: "right", marginTop: -10 }}
                onClick={() => {
                  this.setState({ modoVisualizarEntregador: false });
                }}
              >
                EDITAR
              </Button>
            ) : null}
            <Form>
              <div>
                <h5>Informações gerais</h5>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Nome *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.nome}
                        type="text"
                        placeholder="Nome"
                        onChange={(e) => {
                          this.setState({
                            form: { ...this.state.form, nome: e.target.value },
                          });
                        }}
                      />
                      {this.state.error.nome ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.nome}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>RG *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEntregador}
                        mask="99.999.999-9"
                        className="form-control"
                        value={this.state.form.rg}
                        type="text"
                        placeholder="RG"
                        onChange={(e) => {
                          this.setState({
                            form: { ...this.state.form, rg: e.target.value },
                          });
                        }}
                      />
                      {this.state.error.rg ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.rg}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>CPF *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEntregador}
                        mask="999.999.999-99"
                        className="form-control"
                        value={this.state.form.cpf}
                        type="text"
                        placeholder="CPF"
                        onChange={(e) => {
                          this.setState({
                            form: { ...this.state.form, cpf: e.target.value },
                          });
                        }}
                      />
                      {this.state.error.cpf ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.cpf}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Telefone *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEntregador}
                        mask="(99) 99999-9999"
                        className="form-control"
                        value={this.state.form.telefone}
                        type="text"
                        placeholder="Telefone"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              telefone: e.target.value,
                            },
                          });
                        }}
                      />
                      {this.state.error.telefone ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.telefone}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Carteira de Habilitação *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        maxLength={11}
                        value={this.state.form.cnh}
                        type="text"
                        placeholder="CNH"
                        onChange={(e) => {
                          this.setState({
                            form: { ...this.state.form, cnh: e.target.value },
                          });
                        }}
                      />
                      {this.state.error.cnh ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.cnh}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div>
                <h5>Informações sobre o veículo</h5>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Tipo *</Form.Label>
                      {this.state.form.veiculo ? (
                        <Select
                          isDisabled={this.state.modoVisualizarEntregador}
                          value={this.state.form.veiculo.tipo}
                          onChange={(opt) => {
                            this.setState({
                              form: {
                                ...this.state.form,
                                veiculo: {
                                  ...this.state.form.veiculo,
                                  tipo: opt,
                                },
                              },
                            });
                            document
                              .getElementById("placa-input")
                              .removeAttribute("disabled");
                          }}
                          options={options}
                          placeholder="Tipo"
                        />
                      ) : null}
                      {this.state.error.veiculo.tipo ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.veiculo.tipo}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Placa *</Form.Label>
                      <InputMask
                        disabled={this.state.modoVisualizarEntregador}
                        id="placa-input"
                        className="form-control"
                        value={this.state.form.veiculo.placa}
                        mask={"***-****"}
                        type="text"
                        placeholder="Placa"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              veiculo: {
                                ...this.state.form.veiculo,
                                placa: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.veiculo.placa ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.veiculo.placa}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Capacidade em Kg *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.veiculo.capacidade}
                        type="text"
                        placeholder="Capacidade"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              veiculo: {
                                ...this.state.form.veiculo,
                                capacidade: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.veiculo.capacidade ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.veiculo.capacidade}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div>
                <h5>Endereço</h5>
                <Form.Group>
                  <Form.Label>Digite o CEP *</Form.Label>
                  <FormControl
                    disabled={this.state.modoVisualizarEntregador}
                    className="input-mask"
                    value={this.state.form.endereco.cep}
                    placeholder="CEP"
                    onChange={(e) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          endereco: {
                            ...this.state.form.endereco,
                            cep: e.target.value,
                          },
                        },
                      });
                      const res = ValidarCep(e.target.value);
                      this.setState({ validarCep: res });
                    }}
                    onBlur={() => {
                      this.pesquisarCEP(this.state.form.endereco.cep);
                    }}
                  />
                  {this.state.error.endereco.cep ? (
                    <div>
                      <p style={{ color: "red" }}>{this.state.error.endereco.cep}</p>
                    </div>
                  ) : null}
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Cidade *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.endereco.cidade}
                        type="text"
                        placeholder="Cidade"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                cidade: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.endereco.cidade ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.cidade}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Bairro *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.endereco.bairro}
                        type="text"
                        placeholder="Bairro"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                bairro: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.endereco.bairro ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.bairro}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Rua *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.endereco.rua}
                        type="text"
                        placeholder="Rua"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                rua: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.endereco.rua ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.endereco.rua}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>Número *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.endereco.numero}
                        type="text"
                        placeholder="Número"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              endereco: {
                                ...this.state.form.endereco,
                                numero: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.endereco.numero ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.error.endereco.numero}
                          </p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div>
                <h5>Informações de autenticação</h5>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        disabled={this.state.modoVisualizarEntregador}
                        value={this.state.form.usuario.email}
                        type="email"
                        placeholder="Email"
                        onChange={(e) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              usuario: {
                                ...this.state.form.usuario,
                                email: e.target.value,
                              },
                            },
                          });
                        }}
                      />
                      {this.state.error.usuario.email ? (
                        <div>
                          <p style={{ color: "red" }}>{this.state.error.usuario.email}</p>
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col>
                    {this.state.modoVisualizarEntregador ? (
                      <div style={{ width: 400, margin: "auto" }}>
                        <Button
                          variant="primary"
                          style={{ marginTop: 30, width: 400 }}
                          onClick={() => {
                            this.handleShowModalSenha();
                          }}
                        >
                          Alterar senha
                        </Button>
                      </div>
                    ) : this.state.modoEditarEntregador ? (
                      <div style={{ width: 400, margin: "auto" }}>
                        <Button
                          variant="primary"
                          style={{ marginTop: 30, width: 400 }}
                          onClick={() => {
                            this.handleShowModalSenha();
                          }}
                        >
                          Alterar senha
                        </Button>
                      </div>
                    ) : (
                      <Form.Group>
                        <Form.Label>Senha *</Form.Label>
                        <Form.Control
                          disabled={this.state.modoVisualizarEntregador}
                          value={this.state.form.usuario.senha}
                          type="password"
                          placeholder="Senha"
                          onChange={(e) => {
                            this.setState({
                              form: {
                                ...this.state.form,
                                usuario: {
                                  ...this.state.form.usuario,
                                  senha: e.target.value,
                                },
                              },
                            });
                          }}
                        />
                        {this.state.error.usuario.senha ? (
                          <div>
                            <p style={{ color: "red" }}>
                              {this.state.error.usuario.senha}
                            </p>
                          </div>
                        ) : null}
                      </Form.Group>
                    )}
                  </Col>
                </Row>
              </div>
              <br></br>
              <div>
                <h5>Alterar tipo do entregador</h5>
                <Row>
                  <Col>
                    <IOSSwitch
                      checked={this.state.form.entregador_fixo}
                      disabled={this.state.modoVisualizarEntregador}
                      onChange={(e) =>
                        this.setState({
                          form: {
                            ...this.state.form,
                            entregador_fixo: e.target.checked,
                          },
                        })
                      }
                    />
                    <span>Fixo?: {this.state.form.entregador_fixo ? "Sim" : "Não"}</span>
                  </Col>
                  <span style={{ marginTop: 7 }}>Estabelecimento: </span>
                  <Col>
                    <Select
                      isDisabled={
                        !this.state.form.entregador_fixo ||
                        this.state.modoVisualizarEntregador
                      }
                      value={this.state.form.estabelecimento_fixo}
                      onChange={(opt) => {
                        this.setState({
                          form: {
                            ...this.state.form,
                            estabelecimento_fixo: opt,
                          },
                        });
                      }}
                      options={this.state.estabelecimentos}
                      placeholder="Escolha o estabelecimento"
                    />
                  </Col>
                </Row>
              </div>
              <br></br>
              <br></br>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalEntregador();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarEntregador ? (
              <Button
                disabled={this.state.modoVisualizarEntregador}
                variant="primary"
                onClick={() => {
                  this.editarEntregador();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarEntregador();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o Entregador?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarEntregador(this.state.EntregadorSelecionado);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.showModalSenha}
          onHide={() => {
            this.setState({
              errorCadastro: "",
              error: {
                ...this.state.error,
                usuario: { ...this.state.error.usuario, senha: "" },
              },
            });
            this.handleCloseModalSenha();
          }}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Nova senha</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorSenha === "Senhas não coincidem *" ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorSenha}</p>
              </div>
            ) : null}
            <Form.Group>
              <Form.Label>Senha *</Form.Label>
              <Form.Control
                value={this.state.form.usuario.senha}
                type="password"
                placeholder="Senha"
                onChange={(e) => {
                  this.setState({
                    form: {
                      ...this.state.form,
                      usuario: {
                        ...this.state.form.usuario,
                        senha: e.target.value,
                      },
                    },
                  });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Confirmar senha *</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirmar senha"
                onChange={(e) => {
                  this.setState({ confirmaSenha: e.target.value });
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalSenha();
              }}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.confirmaSenha(this.state.EntregadorSelecionado);
              }}
            >
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
